module.exports = __webpack_public_path__ + "img/casual-life-3d-young-man-holding-blue-smartphone.2eeb05e7.png";